import { TweenMax } from 'gsap';
import { Sprite } from 'pixi.js';
import { getGameSize, IGameSizeInfo } from '../../Config/Levels';
import { createOutlineText } from '../../Utils/Utils';
import { Animation } from '../Animations/Animation';

export class PointsDisplay extends Sprite {
    constructor(pointAmt: number) {
        super();
        const s: IGameSizeInfo = getGameSize();
        const r = new PIXI.Rectangle(0, 0, s.gameWidth * 0.1, s.gameHeight * 0.05);
        // const lifeNumText = createBitmapText(pointAmt.toString(10), r, 'score-font', 72);
        const lifeNumText = createOutlineText(pointAmt.toString(10), r, 'Baloo', 50);
        this.addChild(lifeNumText);
        this.anchor.set(0.5);
        this.alpha = 0;
    }

    public async showPoints() {
        const animation = new Animation({});
        const h = getGameSize().gameHeight;
        animation.add(TweenMax.to(this, 0.5, { alpha: 1, repeat: 1, yoyo: true }));
        animation.addToLast(
            TweenMax.to(this, 1, {
                y: this.y - h * 0.08,
            })
        );
        animation.add(() => this.destroy());
        return animation.play();
    }
}
